import { render, staticRenderFns } from "./modificators.vue?vue&type=template&id=8e16c00e&scoped=true&"
import script from "./modificators.vue?vue&type=script&lang=js&"
export * from "./modificators.vue?vue&type=script&lang=js&"
import style0 from "./modificators.vue?vue&type=style&index=0&id=8e16c00e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e16c00e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e16c00e')) {
      api.createRecord('8e16c00e', component.options)
    } else {
      api.reload('8e16c00e', component.options)
    }
    module.hot.accept("./modificators.vue?vue&type=template&id=8e16c00e&scoped=true&", function () {
      api.rerender('8e16c00e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/modificators.vue"
export default component.exports